import type {
  LoginCredentials,
  LoginResponse,
  CurrentUserResponse,
  RegisterPayload,
  RegisterResponse,
} from '@/api/istaff/auth';
import { makeRequestActionCreator, makeActionCreator } from '@/utils';
import { authSlice } from './slice';

const createAction = makeActionCreator(authSlice.name);
const createRequestAction = makeRequestActionCreator(authSlice.name);

export const login = createRequestAction<LoginCredentials, LoginResponse>(
  'login',
);
export const hydrateAuth = createRequestAction<void, CurrentUserResponse>(
  'hydrateAuth',
);
export const register = createRequestAction<RegisterPayload, RegisterResponse>(
  'register',
);
export const logout = createAction('logout');

export const { setAuth, setUser, setLoginPending, setLoginError, clearAuth } =
  authSlice.actions;
export {
  setRegisterSuccess,
  setRegisterError,
  clearRegisterState,
} from './slice';
